import Request from 'core/api/Request';
import urlResolver from 'edrolo/utils/URLResolver';

const SelfAssessmentAPI = {
  save(branchId, rating) {
    const url = urlResolver.getPath('ajax:self-assessment');

    const data = {
      branch_id: branchId,
      rating,
    };

    return (
      Request.post(url)
        // JSONResponseMixin requires X-Requested-With
        .set('X-Requested-With', 'XMLHttpRequest')
        .send(data)
        .end()
    );
  },
};

export default SelfAssessmentAPI;
